module.exports = __webpack_public_path__ + "static/media/spotify.00e16d60.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/spotify.png
// module id = 43
// module chunks = 0